import LegacyApiService from "./LegacyApiService";

class AppService {
  getInitial() {
    return LegacyApiService.get("/initial");
  }

  getUserSession() {
    return LegacyApiService.get("/user-session");
  }

  login(data) {
    return LegacyApiService.post("/user-session", data);
  }

  logout() {
    return LegacyApiService.delete("/user-session");
  }

  requestResetPasswordCode(data) {
    return LegacyApiService.post("/password-recovery/send-code", data);
  }

  checkResetPasswordCode(data) {
    return LegacyApiService.post("/password-recovery/check-code", data);
  }

  resetPassword(data) {
    return LegacyApiService.post("/password-recovery/reset-password", data);
  }
}

export default new AppService();
